'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
var settings = require('../settings-9ee2f03f.js');
var style = require('../style-222d2b0f.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  ", "\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n"], ["\n  ", "\n  font-size: ", ";\n  font-weight: ", ";\n  color: ", ";\n"]);

var P = styled__default.p(_templateObject, style.textStyle, function (props) {
  return props.size ? props.size : "14px";
}, function (props) {
  return props.weight ? props.weight : "400";
}, function (props) {
  return props.color ? props.color : settings.COLOR.textBlack;
});

var B14 = function (_Component) {
  _babelHelpers.inherits(B14, _Component);

  function B14() {
    _babelHelpers.classCallCheck(this, B14);
    return _babelHelpers.possibleConstructorReturn(this, (B14.__proto__ || Object.getPrototypeOf(B14)).apply(this, arguments));
  }

  _babelHelpers.createClass(B14, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          rest = _babelHelpers.objectWithoutProperties(_props, ["children"]);

      return React__default.createElement(
        P,
        rest,
        children
      );
    }
  }]);
  return B14;
}(React.Component);

B14.propTypes = {
  /** font color */
  color: PropTypes.string,
  /** font font size */
  size: PropTypes.string,
  /** font weight */
  weight: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
B14.defaultProps = {
  size: "14px",
  weight: "400"
};
B14.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "B14",
  "props": {
    "size": {
      "defaultValue": {
        "value": "\"14px\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "font font size"
    },
    "weight": {
      "defaultValue": {
        "value": "\"400\"",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "font weight"
    },
    "color": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "font color"
    }
  }
};

exports.P = P;
exports.default = B14;
//# sourceMappingURL=b14.js.map
